import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=19890043&scoped=true&"
import script from "./Person.vue?vue&type=script&lang=js&"
export * from "./Person.vue?vue&type=script&lang=js&"
import style0 from "./Person.vue?vue&type=style&index=0&id=19890043&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19890043",
  null
  
)

export default component.exports